module.exports = __webpack_public_path__ + "static/media/AC_on.316f1884.svg";